import { treeToList } from '@/utils';
import { Suspense, useLayoutEffect, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from './index';

const generateRoute = ({
  routes,
  path,
  component: Component,
  tabBars,
  ...other
}: any) => (
  <Route path={path} key={path} element={<Component />} {...other}>
    {(routes || tabBars)?.map((v: any) => generateRoute(v))}
  </Route>
);

const routeList = treeToList(routes, ['routes', 'tabBars']);

const handler = (e: any) => {
  e.stopPropagation();
  e.preventDefault();
};

const RouteRender = () => {
  const routesView = useMemo(() => {
    return routes.map((v) => generateRoute(v));
  }, []);

  useLayoutEffect(() => {
    document.removeEventListener('click', handler, true);
  }, []);

  document.title =
    routeList.find((v) => v.path === location.pathname)?.title ||
    document.title;

  return (
    <Suspense fallback={null}>
      <Routes location={location}>{routesView}</Routes>
    </Suspense>
  );
};
export default RouteRender;
